import React, {useContext, useState} from 'react';
import {DispatchContext} from '../../../store';
import {taskPoolServices} from '../../../services/TaskPoolServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import Card from '@mui/material/Card';
import FileUpload from '../../../common/ImageUpload/FileUpload';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});
export default function AcceptTransfer(props) {
  const dispatch = useContext(DispatchContext);
  const {open, handleAction, roleId, taskPool} = props;
  const [loanImgIds, setLoanImgIds] = useState([]);

  const poolId = taskPool?.map(value => value?.role_id);

  const isRoleIdInPool = poolId.includes(roleId);

  let taskPoolId = null;

  if (isRoleIdInPool) {
    const index = poolId.indexOf(roleId);

    if (index !== -1) {
      taskPoolId = taskPool[index]?.id;
    }
  }

  const onSubmit = async () => {
    const supportingDocuments = {
      supporting_doc_ids: loanImgIds?.map(val => val)
    }
    taskPoolServices('put', taskPoolId, {action: 'approve', ...supportingDocuments}).then(response => {
      dispatch({type: 'STATE', payload: {change: true}});
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Loan approved successfully'}
      });
      handleAction();
    });
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAction}
        aria-describedby="alert-dialog-slide-description"
      >
        <Formik initialValues={{supporting_doc_ids: ''}}
                onSubmit={onSubmit}
                validateOnBlur={true} enableReinitialize
        >
          {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
            <Form>
              <div>
                <DialogTitle align={'center'} color={'#616B88'} sx={{fontSize: 25}} className={'text-bold'}
                             fontWeight={700}>
                  Approve Catalogue Transfer
                </DialogTitle>
                <Box className={'common-divider'}/>
                <DialogContent sx={{width: 400}}>
                  <Typography sx={{mb: 2}}>
                    Are you sure you want to accept this catalog transfer?
                  </Typography>
                  <FileUpload setImageId={setLoanImgIds}/>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleAction} variant={'outlined'}
                          color={'error'} className={'text-capitalize'}>
                    Cancel
                  </Button>
                  <Button variant={'contained'} type={'submit'} className={'text-capitalize'}>Confirm</Button>
                </DialogActions>
              </div>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
}